import React, { Component } from "react";

import html from "react-inner-html";
import { Link } from "react-router-dom";

import SubAsset from "./subasset";
import BuyModal from "./buy-modal";

import PreviousList from "./previous-list";
import AuctionList from "./auction-list";

import "./asset.css";

import Loading from "../../components/Loading";
import ShowValue from "../../components/ShowValue";
import MessageModal from "../../components/Message";

import ApiBuy from "../../utils/api.buy";
import ApiAssets from "../../utils/api.assets";
import ApiAuction from "../../utils/api.auction";
import AuthService from "../../utils/auth.service";
import LeaveMessageInput from "./leave-message-modal";

declare var location;
declare var FB;

const LEVEL_TRANSFORM = ["stars", "planets", "moons", "craters", "lots"];

class AssetPage extends Component {
  authService = AuthService;

  constructor(props) {
    super(props);

    let current = props.asset.key;

    let query = {};
    if (location.search) {
      let queryStr = location.search;

      if (location.search.includes(current)) {
        let queryA = location.search;
        queryA.substr(1, queryA.length - 1).split("&").forEach(str => {
          let parse = str.split("=");
          query[parse[0]] = parse[1];
        });
        const queryArr = query.assetline.split(",");
        queryArr.pop();
        queryArr.push(current);
        query.assetline = queryArr.join(",");
      } else {
        queryStr.substr(1, queryStr.length - 1).split("&").forEach(str => {
          let parse = str.split("=");
          query[parse[0]] = parse[1];
        });
        const queryArr = query.assetline.split(",");
        queryArr.pop();
        queryArr.push(current);
        query.assetline = queryArr.join(",");
      }
    }

    this.state = {
      current: {
        previous_landers: [{}],
        balances: {},
        auction: { auction_list: [{}] }
      },
      transaction: { transaction: [] },
      childs: [],
      assetline: query.assetline,
      landers_loading: false,
      modal: {
        title: "Auction Status",
        message: "",
        isOpen: false
      },
      auctionModal: { isOpen: false },
      leaveMessageModal: { isOpen: false },
      auctionform: { value: 10000, minimumBid: 10000 },
      profile: AuthService.currentUser,
      value: 0.0,
      buying: false,
      isOpen: false,
      loading: true,
      asset: this.props.asset,
      easterEggsClicks: {},
      easterEggsOpen: false
    };

    this.loadFullAsset = this.loadFullAsset.bind(this);
    this.toggle = this.toggle.bind(this);
    this.buyAsset = this.buyAsset.bind(this);
    this.shareFB = this.shareFB.bind(this);
    this.backPage = this.backPage.bind(this);
    this.toggleAuction = this.toggleAuction.bind(this);
    this.handleAuctionSubmit = this.handleAuctionSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.changeModalStatus = this.changeModalStatus.bind(this);
    this.toggleLeaveMessageModal = this.toggleLeaveMessageModal.bind(this);
    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.changeAssetLine = this.changeAssetLine.bind(this);
    this.getClick = this.getClick.bind(this);
    this.classetWhitEasterEggs = this.classetWhitEasterEggs.bind(this);
  }

  componentWillMount() {
    if (this.state.asset) {
      this.setState(...this.state, { loading: true, asset: this.props.asset });
      this.loadFullAsset(this.state.asset);
    }
  }

  componentWillReceiveProps(props) {
    if (props) {
      this.setState(...this.state, { loading: true, asset: props.asset });
      this.loadFullAsset(props.asset);
    }
  }

  updateProfile(profile) {
    this.setState(...this.state, { profile: AuthService.currentUser });
  }

  buyAsset() {
    this.setState(...this.state, { profile: AuthService.currentUser, loading: true });

    new ApiBuy().buy(this.state.assetline).then(response => {
      if (response.data) {
        response.data.transaction = response.data.transaction ? response.data.transaction : [];

        this.setState(...this.state, { isOpen: true, transaction: response.data, loading: false });
      }
    });
  }

  changeModalStatus(title, message) {
    this.setState(...this.state, {
      modal: { title: title, message: message, isOpen: true }
    });
  }

  toggleMessageModal() {
    this.setState(...this.state, { modal: { isOpen: false } });
  }

  toggleAuction() {
    this.setState(...this.state, {
      auctionModal: { isOpen: !this.state.auctionModal.isOpen }
    });
  }

  toggleLeaveMessageModal() {
    this.setState({
      leaveMessageModal: { isOpen: !this.state.leaveMessageModal.isOpen }
    });
  }

  handleInput(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let form = this.state.auctionform;

    if (target.type === "number") {
      form[name] = Number(value);
    } else {
      form[name] = value;
    }

    this.setState(...this.state, { auctionform: form });
  }

  handleAuctionSubmit() {
    let auctionService = new ApiAuction();

    if (
      this.state.auctionform.value &&
      this.state.auctionform.value >= this.state.auctionform.minimumBid
    ) {
      this.setState(...this.state, { loading: true });

      /* Uid ??????  AuctionService.py */
      auctionService.post(this.state.assetline, this.state.auctionform).then(data => {
        let auctionList = this.state.current.auction.auction_list;

        if (data.data.status == 201) {
          this.authService.refresh();
          /* Reset auction list */
          this.changeAssetLine(this.state.assetline);
        }

        this.changeModalStatus("Auction Message", data.data.message);
        this.toggleAuction();
        this.setState(...this.state, { loading: false });
      }).catch(err => {
        this.setState(...this.state, { loading: false });
      });
    } else {
      this.changeModalStatus("Opps...", `Offer must be greater than (or equal to) : ${Number(this.state.current.auction.auction_min) + Number(this.state.current.auction.auction_step)}`);
    }
  }

  toggle() {
    this.setState(...this.state, { isOpen: !this.state.isOpen });
  }

  shareFB() {
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Hey facebook friends, I own an asset at Cryptolands.io! Check this out. The asset name is ${
          this.state.current.name
          }!`,
        href: location.href
      },
      function (response) { }
    );
  }

  changeAssetLine(assetline) {
    this.props.loadCurrentAsset(assetline);
  }

  backPage() {
    let queryStr = location.search, query = {};

    queryStr.substr(1, queryStr.length - 1).split("&").forEach(str => {
      let parse = str.split("=");
      query[parse[0]] = parse[1];
    });

    let assetline = this.state.assetline.split(",");
    assetline.pop();

    let goTo = assetline.join(","), url = "";

    if (goTo === "sun") {
      url = "/planets";
    } else {
      url = "/assets/?assetline=" + goTo;
    }

    return url;
  }

  loadFullAsset(asset) {
    let childs = [];

    if (asset.info.level < 6) {
      let child = asset[LEVEL_TRANSFORM[asset.info.level]];
      if (child) {
        childs = Object.keys(child).map(key => {
          let tChild = child[key];
          tChild["key"] = key;

          if (tChild.info.level === 4 || tChild.info.level === 5) {
            if (tChild.info.owner_message) {
              tChild.info.image = "/assets/images/bandeira.png";
            } else {
              tChild.info.image = "/assets/images/mark.png";
            }
          }

          tChild["assetline"] = `/assets/?assetline=${this.state.assetline},${key}`;

          if (tChild.info.position) {
            let borderRadius = tChild.info.level === 5 ? 0 : 75;

            tChild["style"] = {
              left: tChild.info.position.x - 15,
              top: tChild.info.position.y - 170,
              borderRadius: borderRadius,
              width: tChild.info.size.width,
              height: tChild.info.size.height
            };
          }

          return tChild;
        });
      }
    }

    asset.info.level_name = asset.level_name = LEVEL_TRANSFORM[asset.info.level - 1].charAt(0).toUpperCase() + LEVEL_TRANSFORM[asset.info.level - 1].slice(1).replace("s", "");

    this.setState(...this.state, {
      current: asset.info,
      childs: childs,
      loading: false,
      landers_loading: true
    });

    let BestOffer = 0;

    if (asset.info.auction) {
      if (asset.info.auction.auction_list && asset.info.auction.auction_list.length) {
        BestOffer = asset.info.auction.auction_list[0].value;
      } else {
        BestOffer = asset.info.auction.auction_min;
      }

      const minimumBid = BestOffer + asset.info.auction.auction_step;
      this.setState(...this.state, {
        auctionform: { value: minimumBid, minimumBid: minimumBid }
      });
    }
  }

  getClick(type) {
    if (type !== undefined && type !== null) {
      let clicks = this.state.easterEggsClicks[type];
      if (clicks) {
        clicks++;
      } else {
        clicks = 1;
      }
      this.setState({
        easterEggsClicks: { ...this.state.easterEggsClicks, [type]: clicks }
      });
    }
  }

  classetWhitEasterEggs(classet) {
    let hideMainImg = false;
    let hideMainVideo = false;
    if (classet.info.easter_egg) {
      const easter_eggs = classet.info.easter_egg.map(item => {
        if (item.category === 'video') {
          if (this.state.easterEggsClicks[item.type] > item.qtd) {
            item.hidden = false;
            hideMainImg = true;
            hideMainVideo = true;
          } else {
            item.hidden = true;
            hideMainImg = false;
            hideMainVideo = false;
          }
        }
        if (item.category === 'image') {
          if (this.state.easterEggsClicks[item.type] > item.qtd) {
            item.hidden = false;
            hideMainVideo = true;
            hideMainImg = true;
          } else {
            item.hidden = true;
            hideMainVideo = false;
            hideMainImg = false;
          }
        }
        return item;
      });
      classet.info.hideMainImg = hideMainImg;
      classet.info.hideMainVideo = hideMainVideo;
      return easter_eggs.map(item => {
        return (
          <div hidden={item.hidden}>
            <div hidden={item.hidden || !item || item.category !== "image"}>
              <img src={item && item.category === "image" ? item.url : classet.info.image} width="250px" height="250px" />
            </div>
            <div hidden={item.hidden || !item || item.category !== "video"}>
              <video height="250px" width="250px" controls preload>
                <source src={classet.info.easter_egg && item.category === "video" ? item.url : classet.info.image} type="video/webm" />
                <source src={classet.info.easter_egg && item.category === "video" ? item.url : classet.info.image} type="video/mp4" />
              </video>
            </div>
          </div>
        );
      });
    }
  }

  render() {
    return (
      <section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="pt-5 mt-5" hidden={this.state.loading}>
                <h1 className="asset-title" onClick={() => { this.getClick('asset-title') }}>
                  {this.state.asset.info.level_name}:{" "}
                  {this.state.asset.info.name === this.state.asset.info.level_name ? "" : this.state.asset.info.name}
                </h1>{" "}
                {/* Asset Name*/}
                <div className="asset-description">
                  <span hidden={this.state.asset.info.on_sale || this.state.asset.info.auction}>
                    {this.state.asset.info.name} is NOT on sale ... yet... <br />
                  </span>
                  <span hidden={!this.state.asset.info.auction || this.state.asset.info.on_sale} >
                    {this.state.asset.info.name} is IN Auction!!! <br />
                  </span>
                  <span hidden={!this.state.asset.info.on_sale || this.state.asset.info.owner_message}>
                    {this.state.asset.info.name} is ON SALE!!! <br />
                  </span>
                </div>{" "}
                {/* ON SALE - NOT  */}
                <div className="asset-view">
                  {this.classetWhitEasterEggs(this.state.asset)}
                  <div hidden={this.state.asset.info.video || this.state.asset.info.hideMainImg}>
                    <img src={this.state.asset.info.image} width="250" height="250" />
                  </div>
                  <div hidden={!this.state.asset.info.video || this.state.asset.info.hideMainVideo}>
                    <video height="250px" width="250px" controls preload>
                      <source src={this.state.asset.info.video} type="video/webm" />
                      <source src={this.state.asset.info.video} type="video/mp4" />
                    </video>
                  </div>
                  {this.state.childs.map(child => (
                    <SubAsset key={child.key} child={child} />
                  ))}
                </div>{" "}
                {/* Image and Sub Assets */}
                <h3 className="asset-price" hidden={!this.state.asset.info.on_sale} onClick={() => { this.getClick('asset-price') }}>
                  <ShowValue btc={this.state.asset.info.previous_landers[0].previous_lander_asset_price} />
                </h3>{" "}
                {/* Price */}
                <p className="asset-description" {...html(this.state.asset.info.description)} onClick={() => { this.getClick('asset-description') }} />
                <hr />
                <a target="_blank" className="float-right" hidden={!this.state.asset.info.wiki} href={this.state.asset.info.wiki}>
                  About {this.state.asset.info.name}{" "}
                  <i className="fas fa-external-link-alt pb-1" />
                </a>{" "}
                {/* About Asset */}
                <br />
                <p
                  className="text-right asset-description"
                  hidden={this.state.profile.lander_btc_address !== this.state.asset.info.previous_landers[0].previous_lander_btc_address}
                >
                  This {this.state.asset.info.level_name} belongs to you. Tell
                  your friends...
                </p>
                <hr />
                <p>
                  <span hidden={!this.state.asset.info.owner_message}>
                    Owner message:{" "}
                  </span>
                  <h5 hidden={!this.state.asset.info.owner_message}>
                    {this.state.asset.info.owner_message}
                  </h5>
                </p>
                <hr hidden={!this.state.asset.info.owner_message} />
                <Link className="btn btn-outline-secondary" to={this.backPage()} hidden={this.state.auctionModal.isOpen}>
                  <i className="fas fa-caret-left" />
                  Back
                </Link>{" "}
                {/* Back Button */}
                <Link className="btn btn-outline-secondary float-right" to={this.backPage()} hidden={this.state.asset.info.auction || this.state.asset.info.on_sale}>
                  <i className="fas fa-caret-left" />
                  Not On Sale
                </Link>{" "}
                {/* Not On Sale */}
                <button
                  hidden={!this.state.asset.info.auction || this.state.asset.info.on_sale || !this.state.profile.btc_founds || this.state.auctionModal.isOpen}
                  onClick={this.toggleAuction}
                  className="btn btn-outline-warning float-right"
                >
                  Make an Offer
                </button>{" "}
                {/* Make an Offer */}
                <button
                  className="btn btn-outline-success float-right"
                  onClick={this.buyAsset}
                  hidden={!this.state.asset.info.on_sale || this.state.profile.lander_btc_address === this.state.asset.info.previous_landers[0].previous_lander_btc_address}
                >
                  Buy now
                  <i className="fab fa-bitcoin" />
                </button>{" "}
                {/* Share Button */}
                <button
                  className="btn btn-outline-primary float-right"
                  hidden={this.state.profile.lander_btc_address !== this.state.asset.info.previous_landers[0].previous_lander_btc_address}
                  onClick={this.shareFB}
                >
                  <i className="fab fa-facebook-f" />
                  Share
                </button>{" "}
                {/* Message Button */}
                <button
                  className="btn btn-outline-info float-right"
                  hidden={this.state.profile.lander_btc_address !== this.state.asset.info.previous_landers[0].previous_lander_btc_address}
                  onClick={this.toggleLeaveMessageModal}
                >
                  <i class="fa fa-envelope" />
                  Message
                </button>{" "}
                {/* Auction Stuff */}
                <hr />
                <p
                  className="asset-description"
                  hidden={this.state.profile.btc_founds || this.state.asset.info.on_sale || !this.state.asset.info.auction}
                >
                  You must login to make an offer...
                </p>{" "}
                {/* Must login */}
                <div className="asset-description" hidden={!this.state.auctionModal.isOpen || !this.state.profile}>
                  <p>
                    Auction will last until{" "}
                    {this.state.asset.info.auction ? this.state.asset.info.auction.auction_message : ""}
                    {this.state.asset.info.auction ? this.state.asset.info.auction.auction_rule : ""}
                    .
                  </p>
                  <div className="row">
                    <div className="col-md-8">
                      <p className="float-left">Minimum offer :</p>
                      <p className="float-right">
                        <ShowValue btc={this.state.auctionform.minimumBid} withoutBreak={true} />
                      </p>
                    </div>
                  </div>{" "}
                  {/* Row Min */}
                  <div className="row" hidden={!this.state.profile}>
                    <div className="col-md-8">
                      <p className="float-left">Your balance :</p>
                      <p className="float-right">
                        <strong>
                          <ShowValue btc={Number(this.state.profile ? Number(this.state.profile.btc_founds) - Number(this.state.profile.reserved_auction) : 0)} withoutBreak={true} />
                        </strong>
                      </p>
                    </div>
                  </div>{" "}
                  {/* Current balance*/}
                  <hr />
                  <p hidden={!this.state.profile || !(this.state.auctionform.minimumBid + 10000 > Number(this.state.profile ? this.state.profile.btc_founds : 0) - Number(this.state.profile ? this.state.profile.reserved_auction : 0))} >
                    Unfortunately you do not have sufficient funds available to
                    make an offer... <hr />
                    Remember the Blockchain fee: 10,000 Sats...
                  </p>
                  <form
                    onSubmit={this.handleAuctionSubmit}
                    hidden={this.state.auctionform.minimumBid + 10000 > Number(this.state.profile ? this.state.profile.btc_founds : 0) - Number(this.state.profile ? this.state.profile.reserved_auction : 0)}
                  >
                    <div className="form-group col-md-6">
                      <label htmlFor="address">
                        Enter offer amount in Sats:{" "}
                      </label>
                      <input
                        type="number"
                        step={this.state.asset.info.auction ? this.state.asset.info.auction.auction_step : 0}
                        min={this.state.auctionform.minimumBid}
                        className="form-control"
                        name="value"
                        value={this.state.auctionform.value}
                        onChange={this.handleInput}
                        required
                      />
                      <p className="text-muted" hidden={!this.state.auctionform.value}>
                        Plus Blockchain fee:
                        <ShowValue btc={this.state.auctionform.value + 10000} withoutBreak={true} />
                      </p>
                    </div>{" "}
                    {/* Form Group*/}
                    <div hidden={!(this.state.profile ? this.state.profile.tfa_active : false)} className="form-group col-md-6">
                      <div className="row">
                        <div className="col-md-12">
                          <label htmlFor="address">Enter TFA code: </label>
                          <input type="text" name="code" placeholder="Your TFA:" maxLength="6" className="form-control" onChange={this.handleInput} value={this.state.auctionform.code} />
                        </div>{" "}
                        {/* Col */}
                      </div>{" "}
                      {/* row */}
                    </div>{" "}
                    {/* TFA */}
                  </form>
                  <div className="row">
                    <div className="col-md-8">
                      <button className="btn btn-outline-secondary float-left" onClick={this.toggleAuction}>
                        <i className="fas fa-caret-left" />
                        Back
                      </button>
                      <button
                        className="btn btn-outline-warning float-right"
                        onClick={this.handleAuctionSubmit}
                        hidden={this.state.auctionform.value + 10000 > Number(this.state.profile ? this.state.profile.btc_founds : 0) - Number(this.state.profile ? this.state.profile.reserved_auction : 0) || !this.state.auctionform.value}
                      >
                        Confirm Offer
                      </button>{" "}
                      {/* Confirm Offer */}
                    </div>{" "}
                    {/* Col buttons*/}
                  </div>{" "}
                  {/* Row buttons */}
                </div>{" "}
                {/* Auction Insertion*/}
              </div>
            </div>{" "}
            {/* Classet */}
            <div className="col-md-4" hidden={this.state.asset.info.auction && !this.state.asset.info.on_sale}>
              <PreviousList assetline={this.state.assetline ? this.state.assetline : ""} classetLanders={this.state.asset.info.previous_landers} />
            </div>{" "}
            {/* Previous list */}
            <div className="col-md-4" hidden={!this.state.asset.info.auction || this.state.asset.info.on_sale}>
              <AuctionList
                auctionlist={this.state.asset.info.auction && this.state.asset.info.auction.auction_list ? this.state.asset.info.auction.auction_list : []}
              />
            </div>{" "}
            {/* Auction list */}
          </div>
        </div>

        <LeaveMessageInput
          assetline={this.state.assetline ? this.state.assetline : ""}
          openModalMessageOwner={this.state.leaveMessageModal.isOpen}
          toggleLeaveMessageModal={this.toggleLeaveMessageModal}
          ownerMessage={this.state.asset.info.owner_message ? this.state.asset.info.owner_message : ""}
          owner={this.state.profile}
          changeAssetLine={this.changeAssetLine}
        />

        <BuyModal
          current={this.state.asset.info}
          transaction={this.state.transaction}
          buyAsset={this.buyAsset}
          isOpen={this.state.isOpen}
          changeAssetLine={this.changeAssetLine}
          toggle={this.toggle}
        />
        {/*<AuctionModal toggle={ this.toggleAuction }
                isOpen={ this.state.auctionModal.isOpen }
                auction={this.state.asset.info.auction}
                
                assetName={ this.state.asset.info.name }
                assetline={ this.state.assetline }
              assetImage={ this.state.asset.info.image}/> */}
        <MessageModal title={this.state.modal.title} message={this.state.modal.message} isOpen={this.state.modal.isOpen} toggle={this.toggleMessageModal} />

        <Loading active={this.state.loading} />
      </section >
    );
  }
}

export default AssetPage;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/index.js